<template>
  <LayoutDefault
    isShowHeader
    title="Учетная запись"
    isShowFooter
    customFooter
  >
    <div class="user-page" v-if="authData">
      <PersonIcon type-img="big"/>
      <div class="user-page__info">
        <div class="user-page__table">
          <div class="user-page__table-item">
            <p>Фамилия:</p>
            {{ firstName }}
          </div>
          <div class="user-page__table-item">
            <p>Имя:</p>
            {{ lastName}}
          </div>
          <div class="user-page__table-item">
            <p>Отчество:</p>
            {{ middleName }}
          </div>
          <div class="user-page__table-item">
            <P>Роль:</P>
            <span v-if="authData.IsAdmin">Админ</span>
            <span v-else>Пользователь</span>
          </div>
          <div class="user-page__table-item">
            <p>Логин:</p>
            {{ authData.Login }}
          </div>
        </div>
        <BaseBtnNew
          name="Сменить пароль"
          @click-btn="switchPassModal(true)"
        >
        <ChangePasswordIcon/>
        </BaseBtnNew>
      </div>
    </div>

    <MiniModal
      v-show="passModal"
      title="Смена пароля"
      first-button-text="Подтвердить"
      :close-modal="switchPassModal"
      @click-save="changePassword"
    >
      <div class="user-page__modal">
        <div class="user-page__modal-item">
          <p>Старый пароль:</p>
          <Password
            id="username"
            v-model="passObj.OldPassword"
            type="password"
            :feedback="false"
            toggleMask
            placeholder="Введите старый пароль"
          />
        </div>

        <div class="user-page__modal-item">
          <p>Новый пароль:</p>
          <Password
            id="username"
            v-model="passObj.NewPassword"
            type="password"
            :feedback="false"
            toggleMask
            placeholder="Введите новый пароль"
          />
        </div>

      </div>
    </MiniModal>
    <template #customFooter>
      <div class="user-page__footer">
        <BaseBtnNew
          name="Назад"
          @click-btn="goExit"
        >
        <ArrowBackIcon/>
        </BaseBtnNew>
      </div>
    </template>
  </LayoutDefault>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import router from '@/router'

import LayoutDefault from '@/layout/LayoutDefault.vue'
import PersonIcon from '@/components/icons/PersonIcon.vue'
import ChangePasswordIcon from '@/components/icons/ChangePasswordIcon.vue'
import ArrowBackIcon from '@/components/icons/ArrowBackIcon.vue'
import BaseBtnNew from '@/components/ui/BaseBtnNew.vue'
import MiniModal from '@/components/modals/MiniModal.vue'

import Password from 'primevue/password'

export default {
  name: 'UserView',
  components: {
    LayoutDefault,
    PersonIcon,
    ChangePasswordIcon,
    BaseBtnNew,
    MiniModal,
    Password,
    ArrowBackIcon
  },
  setup () {
    const store = useStore()
    const passModal = ref(false)

    const authData = computed(() => store.getters.getAuthenticatedData)

    const passObj = ref({
      UserId: 0,
      OldPassword: '',
      NewPassword: ''
    })

    const firstName = computed(() => {
      if (!authData.value?.DisplayName) return ''
      const parts = authData.value.DisplayName.trim().split(' ')
      return parts[1] || parts[0] || '' // Имя обычно второе или первое, если нет фамилии
    })

    const lastName = computed(() => {
      if (!authData.value?.DisplayName) return ''
      const parts = authData.value.DisplayName.trim().split(' ')
      return parts[0] || '' // Фамилия обычно первая
    })

    const middleName = computed(() => {
      if (!authData.value?.DisplayName) return ''
      const parts = authData.value.DisplayName.trim().split(' ')
      return parts[2] || '' // Отчество обычно третье
    })

    const switchPassModal = (val) => { passModal.value = val }

    const changePassword = async () => {
      passObj.value.UserId = authData.value.UserId

      await store.dispatch('setChangePassword', passObj.value)

      passObj.value.NewPassword = ''
      passObj.value.OldPassword = ''

      switchPassModal(false)
    }

    const goExit = () => { router.go(-1) }

    return {
      passModal,
      switchPassModal,
      passObj,
      changePassword,
      authData,
      goExit,
      firstName,
      lastName,
      middleName
    }
  }
}
</script>

<style lang="scss" scoped>
.user-page {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: start;
  gap: 40px;
  height: 95%;

  &__info {
    text-align: start;
  }

  &__table {
    display: flex;
    flex-direction: column;
    gap: 10px;

    &-item {
      font-weight: 400;
      font-size: 16px;
      color: #00000059;
      padding: 10px 12px;

      p {
        font-weight: 500;
        font-size: 18px;
        color: #000000;
        margin-bottom: 18px;
      }
    }
  }

  &__pass {
    display: flex;
    flex-direction: column;
    height: 220px;
    justify-content: center;
  }

  &__modal {
    display: flex;
    flex-direction: column;
    gap: 24px;

    &-item {
      display: flex;
      flex-direction: column;
      gap: 8px;
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      text-align: start;
    }
  }
}
:deep(.base-button) {
  width: 200px;
}

:deep(.footer) {
  justify-content: flex-end !important;
}

:deep(.p-inputtext) {
  width: 483px;
  border: 1px solid #000000;
  // -webkit-box-shadow: inset 0 0 0 50px white;
}

:deep(.p-inputtext:enabled:hover) {
  border-color: #00ABEC;
}

:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem #00ABEC;
  border-color: #00ABEC;
  -webkit-box-shadow: inset 0 0 0 50px white;
}

</style>
